export default (user) => {
  return user?.user.displayName
    ? user?.user.displayName
    : user?.user.email.split("@")[0];
};
